import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'oreToCrown' })
export class OreToCrownPipe implements PipeTransform {
  transform(value: number, divider?: number, discount?: number) {
    let crowns: number = value / 100;

    // if You want to divide number f.e by months
    if (divider) {
      crowns = crowns / divider;
    }

    if (discount) {
      crowns = crowns - (crowns / 100) * discount;
    }

    // return decimals only if != .00
    return crowns % 1 === 0 ? crowns : crowns.toFixed(2);
  }
}
